import React from "react";
import { MDBBadge, MDBBtn } from "mdbreact";
import { currency } from "../../../../../../services/utilities";

// "October 16, 2026" -> 16 Friday; the month only when it is not the one on the calendar
const toDay = (title = "", month, year) => {
  const date = new Date(title);
  if (isNaN(date)) return { day: title, weekday: "", other: "" };
  const isOtherMonth =
    date.getMonth() + 1 !== Number(month) || date.getFullYear() !== Number(year);
  return {
    day: date.getDate(),
    weekday: date.toLocaleDateString("en-PH", { weekday: "long" }),
    other: isOtherMonth
      ? date.toLocaleDateString("en-PH", { month: "short", year: "numeric" })
      : "",
  };
};

const Header = ({
  sum,
  count,
  title,
  month,
  year,
  isOpen,
  textColor,
  index,
  setActiveId,
}) => {
  const { day, weekday, other } = toDay(title, month, year);
  return (
    <div
      className={`d-flex justify-content-between align-items-center ${textColor}`}
    >
      <span title={title}>
        <strong>{day}</strong>
        {weekday && <span className="ml-2">{weekday}</span>}
        {other && (
          <MDBBadge
            color="warning"
            className="ml-2"
            title="A sendout from another month that is still not billed (no SOA yet)"
          >
            {other} · not yet billed
          </MDBBadge>
        )}
      </span>
      <div className="d-flex align-items-center">
        <small className="mr-3 text-muted">
          {count} sendout{count > 1 ? "s" : ""}
        </small>
        <span className="font-weight-bold mr-2">{currency.format(sum)}</span>
        <MDBBtn
          size="sm"
          color="white"
          rounded
          onClick={() => setActiveId((prev) => (index === prev ? -1 : index))}
          className="m-0 p-0 transition-all "
          style={{ width: isOpen ? "1.5rem" : "2rem" }}
        >
          <i
            style={{ rotate: `${isOpen ? 0 : 90}deg` }}
            className="fa fa-angle-down transition-all "
          />
        </MDBBtn>
      </div>
    </div>
  );
};

export default Header;
